var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "right-menu-item pointer boxHover",
    staticStyle: {
      "margin-right": "15px",
      position: "relative"
    }
  }, [_c("a-popover", {
    staticStyle: {
      "z-index": "999"
    },
    attrs: {
      title: "Title",
      trigger: "hover",
      overlayStyle: {
        zIndex: 999
      },
      overlayClassName: "notice-popover",
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("template", {
    slot: "content"
  }, [_c("a-tabs", {
    staticStyle: {
      width: "300px"
    },
    model: {
      value: _vm.activeKey,
      callback: function ($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, [_c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: _vm.$t("全部消息"),
      "force-render": ""
    }
  }, [_c("div", {
    ref: "all",
    staticClass: "message-list"
  }, [_vm.allMessageList.length === 0 ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v(" " + _vm._s(_vm.$t("暂无数据")) + " ")]) : _vm._e(), _vm._l(_vm.allMessageList, function (item) {
    return _c("div", {
      key: "all" + item.id,
      staticClass: "message-item",
      on: {
        click: function ($event) {
          return _vm.toDetail(item);
        }
      }
    }, [item.readingStatus === 0 ? _c("span", {
      staticClass: "res-circle"
    }) : _vm._e(), _c("div", {
      staticClass: "message-title",
      attrs: {
        title: item.title
      }
    }, [_c("span", [_vm._v(" " + _vm._s(item.title))])]), _c("div", {
      staticClass: "message-content",
      domProps: {
        innerHTML: _vm._s(item.content)
      }
    }), _c("div", {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(item.receptionTime))])]);
  }), _vm.allMessageTotal > 10 ? _c("div", {
    staticClass: "see-more",
    on: {
      click: function ($event) {
        return _vm.seeMore("all");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("查看更多")))]) : _vm._e()], 2)]), _c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: _vm.$t("未读消息"),
      "force-render": ""
    }
  }, [_c("div", {
    ref: "noRead",
    staticClass: "message-list"
  }, [_vm.unreadMessageList.length === 0 ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v(" " + _vm._s(_vm.$t("暂无数据")) + " ")]) : _vm._e(), _vm._l(_vm.unreadMessageList, function (item) {
    return _c("div", {
      key: "unRead" + item.id,
      staticClass: "message-item",
      on: {
        click: function ($event) {
          return _vm.toDetail(item);
        }
      }
    }, [item.readingStatus === 0 ? _c("span", {
      staticClass: "res-circle"
    }) : _vm._e(), _c("div", {
      staticClass: "message-title"
    }, [_c("span", [_vm._v(" " + _vm._s(item.title))])]), _c("div", {
      staticClass: "message-content",
      domProps: {
        innerHTML: _vm._s(item.content)
      }
    }), _c("div", {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(item.receptionTime))])]);
  }), _vm.unreadMessageTotal > 10 ? _c("div", {
    staticClass: "see-more",
    on: {
      click: function ($event) {
        return _vm.seeMore("unRead");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("查看更多")))]) : _vm._e()], 2)])], 1)], 1), _vm.hasUnReadMessage ? _c("div", {
    staticClass: "red-circle"
  }) : _vm._e(), _c("svg-icon", {
    attrs: {
      icon: "bell",
      size: 18
    }
  })], 2), _c("message-detail-model", {
    attrs: {
      "message-info": _vm.messageDetailData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };